// Units API client for unified platform
import { mockUnits } from './mockData.js';

const API_BASE = import.meta.env.VITE_API_BASE || 'https://u5aw5omfkd.execute-api.us-east-2.amazonaws.com/dev';
const USE_MOCK = import.meta.env.VITE_USE_MOCK === 'true';

export async function fetchUnits({ project_id, building_id, all }) {
  try {
    const url = new URL(`${API_BASE}/units`);
    if (project_id) url.searchParams.set('project_id', project_id);
    if (building_id) url.searchParams.set('building_id', building_id);
    if (all) url.searchParams.set('all', 'true');
    
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Units API error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.warn('Units API failed, using mock data:', error.message);
    const items = mockUnits.filter(unit => {
      if (all) return true;
      if (project_id && unit.project_id !== project_id) return false;
      if (building_id && unit.building_id !== building_id) return false;
      return true;
    });
    return { items };
  }
}

export async function listUnitsByProject({ project_id }) {
  return fetchUnits({ project_id });
}

export async function listAllUnits() {
  return fetchUnits({ all: true });
}
